<mat-card [ngClass]="{ 'normal': node?.visible, 'noVisible': !node?.visible }">
    <div *ngIf="this.node.type!==NodeType.FAQ"  >
        <a (click)="selectNode()">{{this.node.name}}</a>
        <div *ngIf="displayAnswer">
            <span>{{node.answer}}</span>
        </div>
        <div style="padding-top: 10px;" *ngIf="habilitado">
            <span class="boton-nodo-faq">
                <button mat-raised-button (click)="editNode()">Editar</button>
            </span>
            <span class="boton-nodo-faq">
                <button mat-raised-button (click)="deleteNode()" color="warn">Eliminar</button>
            </span>
            <span *ngIf="this.node.type===NodeType.Question">
                <button mat-raised-button (click)="addChildNode()" color="primary">Agregar Hijo</button>
            </span>
        </div>
    </div>
    <div *ngIf="this.node.type===NodeType.FAQ">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <a class="texto-nodo-faq" (click)="selectNode()">{{this.node.url}}</a>
            <span class="boton-nodo-faq" style="float:right; vertical-align: center; display: flexbox;"
                *ngIf="habilitado">
                <button mat-raised-button (click)="deleteNode()" color="warn">Eliminar</button>
            </span>
        </div>
        <div *ngIf="displayAnswer">
            <span>{{node.answer}}</span>
        </div>
    </div>

</mat-card>